import { goCardlessAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { goCardlessAPIUrls } from '../data';

export type DisconnectGoCardless = {
  params: null;
  response: null;
  return: boolean;
};

export const disconnectGoCardless = withLogger(
  async (_params?: null): Promise<boolean> => {
    await goCardlessAxiosClient.get(goCardlessAPIUrls.disconnect);

    return true;
  },
);
